import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your Firebase configuration object from the Firebase console
// const firebaseConfig = {
//     apiKey: "AIzaSyAFd7WnKTO4f9DNBa1dbDEX0daXxpTaAtM",
//     authDomain: "susten-poc.firebaseapp.com",
//     projectId: "susten-poc",
//     storageBucket: "susten-poc.appspot.com",
//     messagingSenderId: "214254078370",
//     appId: "1:214254078370:web:f7f55dc2ea95fdea6c4afb"
//   };

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: "mahindra-susten-dev-599626.firebasestorage.app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);

export { auth, storage };
